import React from "react";
import { Box, Typography } from "@mui/material";
import SettingsApplicationsOutlinedIcon from "@mui/icons-material/SettingsApplicationsOutlined";
import { useStyles } from "./NoMillSelected.styles";
import { INoMillSelected } from "./NoMillSelectedInterfaces";

export const NoMillSelected = ({ title }: INoMillSelected) => {
    const classes = useStyles();

    return (
        <Box className={classes.container}>
            <SettingsApplicationsOutlinedIcon className={classes.icon} />
            <Typography variant="subtitle1" className={classes.text}>
                {title}
            </Typography>
        </Box>
    );
};
